
<div class="table-settings-row table-settings-default-row">
  <button
    type="button"
    avanoButton
    [label]="tableSettingsTranslationKeys.ResetButtonLabel | translate"
    icon="icon-content-reset"
    (click)="resetTableSettings()"
  ></button>
</div>
<div class="table-settings-row" *ngIf="showRowsPerPageSettings">
  <div class="table-settings-row-label">{{ tableSettingsTranslationKeys.Pagination.ItemsPerPageLabel | translate }}</div>
  <p-autoComplete
    [type]="'number'"
    [ngModel]="rowsPerPage"
    (ngModelChange)="changeRowsPerPage($event)"
    [suggestions]="filteredRowsPerPageOptions"
    [dropdown]="true"
    [forceSelection]="false"
    (completeMethod)="rowsPerPageFilter($event)"
    inputStyleClass="number-input-without-arrows"
    panelStyleClass="avano-scrollbars"
  ></p-autoComplete>
</div>
<div class="table-settings-row">
  <div class="table-settings-row-label">{{ tableSettingsTranslationKeys.Columns.Label | translate }}</div>
  <div class="table-settings-scroll-container avano-scrollbars">
    <div *ngFor="let columnConfig of columnConfigurations">
      <p-checkbox
        [ngModel]="columnConfig.show"
        [binary]="true"
        [label]="columnConfig.header | translate"
        (onChange)="changeColumnVisibility($event.checked, columnConfig.field)"
      ></p-checkbox>
    </div>
  </div>
</div>

